export default function HistoryIconBlue() {
  return (
    <svg width="35" height="35" fill="none" viewBox="0 0 20 20">
      <path
        stroke="#1a3d5d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.9"
        d="M1 1v4.997h5"
      ></path>
      <path
        stroke="#1a3d5d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.9"
        d="M1.05 10.993a8.992 8.992 0 007.797 7.934 9.005 9.005 0 009.553-5.703 8.988 8.988 0 00-3.294-10.622A9.005 9.005 0 004 3.3L1 5.997"
      ></path>
      <path
        stroke="#1a3d5d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.9"
        d="M10 4.997v4.997l4 1.999"
      ></path>
    </svg>
  );
}
